/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestionnaireQuestionImage
 */
export interface QuestionnaireQuestionImage {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireQuestionImage
     */
    base64: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireQuestionImage
     */
    legend: string;
}

/**
 * Check if a given object implements the QuestionnaireQuestionImage interface.
 */
export function instanceOfQuestionnaireQuestionImage(value: object): value is QuestionnaireQuestionImage {
    if (!('base64' in value) || value['base64'] === undefined) return false;
    if (!('legend' in value) || value['legend'] === undefined) return false;
    return true;
}

export function QuestionnaireQuestionImageFromJSON(json: any): QuestionnaireQuestionImage {
    return QuestionnaireQuestionImageFromJSONTyped(json, false);
}

export function QuestionnaireQuestionImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionnaireQuestionImage {
    if (json == null) {
        return json;
    }
    return {
        
        'base64': json['base64'],
        'legend': json['legend'],
    };
}

export function QuestionnaireQuestionImageToJSON(json: any): QuestionnaireQuestionImage {
    return QuestionnaireQuestionImageToJSONTyped(json, false);
}

export function QuestionnaireQuestionImageToJSONTyped(value?: QuestionnaireQuestionImage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base64': value['base64'],
        'legend': value['legend'],
    };
}

